import { call, put, takeEvery, select } from 'redux-saga/effects'
import { change, startSubmit, stopSubmit, getFormValues } from 'redux-form/immutable'
import { v1 as uuidv1 } from 'uuid'
// @ts-ignore
import { promisedCanvasToBlob } from 'helpers/promises/promisedCanvasToBlob'

// @ts-ignore
import { showWarning } from 'store/entities/toastr/utils'
import { uploadFileToS3 } from 'store/entities/api/sagas/s3PolicySagas'
import { addImageToGallery, setIsButtonDisable, uploadImage, setImageForReplace } from 'store/entities/gallery/actions'
import { EDIT_ACTIVITY_FORM_NAME, CREATE_ACTIVITY_FORM_NAME } from 'app/constants/activities'
import { getImageForReplace } from 'store/entities/gallery/selectors'
// @ts-ignore
import { replaceOldImageLinkInActivities } from 'store/entities/protracks/activities/actions'
import imageNameNormalizer from 'helpers/imageNameNormalizer'

import { IParams } from 'store/entities/api/sagas/interfaces'
import { IHandleUploadImageRequest } from 'store/entities/gallery/sagas/interfaces'

export default function* uploadAdminWelcomeEmailImageSaga() {
  yield takeEvery(uploadImage, handleUploadImageRequest)
}

export function* handleUploadImageRequest({ payload }: IHandleUploadImageRequest | any) {
  const { image, formName, formField, s3Entity, isConfirmRewriteImage } = payload
  try {
    const { file, ext, mime, name } = image
    yield put(startSubmit(formName))
    let imagePath
    let oldImagePath
    if (file instanceof HTMLCanvasElement) {
      const blob = yield call(promisedCanvasToBlob, file, mime)
      if (!!name && (formName === EDIT_ACTIVITY_FORM_NAME || formName === CREATE_ACTIVITY_FORM_NAME)) {
        const imageDomainWithId = (yield select(getFormValues(EDIT_ACTIVITY_FORM_NAME))).get('imageDomainWithId')
        const imageDomain = imageDomainWithId.split('_')[1]
        const imageDomainId = imageDomainWithId.split('_')[0]
        const normalizeFileName = imageNameNormalizer(name)
        const fileName = `${imageDomain}__${normalizeFileName}`
        const fileResolution = `${file.width}x${file.height}`
        // please also check related checkImageName saga
        // if image which we want to replace already exist in gallery - get url
        const imageInGallery = yield select(getImageForReplace)
        if (imageInGallery) {
          oldImagePath = imageInGallery?.get('url')
          const hash = uuidv1()
          imagePath = yield call(uploadImageToS3, blob, ext, s3Entity, {
            fileName,
            fileResolution,
            isConfirmRewriteImage,
            imageDomainId,
            hash,
          })
        } else {
          imagePath = yield call(uploadImageToS3, blob, ext, s3Entity, {
            fileName,
            fileResolution,
            isConfirmRewriteImage,
            imageDomainId,
          })
        }
        yield put(setIsButtonDisable(true))
        yield put(setImageForReplace(null))
      } else {
        imagePath = yield call(uploadImageToS3, blob, ext, s3Entity)
      }
    } else {
      const ext = file.name.substring(file.name.lastIndexOf('.') + 1)
      imagePath = yield call(uploadImageToS3, file, ext, s3Entity)
    }
    if (oldImagePath) {
      yield put(replaceOldImageLinkInActivities({ oldImagePath, imagePath }))
    }
    yield put(change(formName, formField, imagePath))
    yield put(addImageToGallery(imagePath, isConfirmRewriteImage))
  } catch (badResponse) {
    showWarning()
  } finally {
    yield put(stopSubmit(formName))
  }
}

export function* uploadImageToS3(file: File | Blob, ext: string, s3Entity: string, params?: IParams) {
  // @ts-ignore
  return yield call(uploadFileToS3, { file, ext, entity: s3Entity, params })
}
